import styled from "@emotion/styled";
import { theme } from "../../utils/theme";
import { TableCell } from "@mui/material";

export const Table = styled.table`
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
`;

export const TableRow = styled.tr``;

export const Th = styled(TableCell)`
  padding: 15px;
  border-bottom: 1px solid #dadada;
  text-align: center;
`;
export const Td = styled(TableCell)`
  border-bottom: 1px solid #dadada;
  padding: 0;
`;

export const Label = styled.label`
  font-weight: normal;
  color: ${theme.palette.text.primary};
`;
export const Textaea = styled.textarea`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #c4c4c4;
  padding: 5px 10px;
  color: ${theme.palette.text.primary};
`;

export const BestSellers = styled.div`
  border-top: 1px solid #979797;
  border-bottom: 1px solid #979797;
  margin-bottom: 20px;
`;
export const AddToCart = styled.button`
  border-radius: 25px;
  border: 1px solid rgba(135, 135, 135, 0.5);
  padding: 5px 15px;
  font-size: 10px;
  text-transform: uppercase;
  color: ${theme.palette.text.primary};
  background-color: ${theme.palette.background.default};
  cursor: pointer;
  &:hover {
    background-color: #007f18;
    color: #fff;
  }
`;

export const BtnPlaceYourOrder = styled.button`
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-radius: 999px;
  border: none;
  background: #eceaf0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  color: #000;
  padding: 16px 40px;
  min-width: min(100%, 300px);

  &:hover {
    background: #e2dfe8;
  }
`;
